import { Button, Typography } from "@suraasa/placebo-ui"
import { LearningCertificateData } from "api/resources/cpat/types"
import { formatDistanceToNow } from "date-fns"
import { useCpat } from "features/Cpat/useCpat"
import { useGlobalContext } from "global/Context/context"
import { Calendar } from "iconoir-react"
import { Link } from "react-router-dom"
import { formatDate } from "utils/helpers"

import CpatCover from "../../../../../assets/Cpat/cpat_cover.webp"

const CpatPreviousReports = () => {
  const { isNcte } = useGlobalContext()
  const { reports, attempt } = useCpat()

  const reportsToRender: LearningCertificateData[] =
    reports.data?.filter(
      report => String(report.referenceId) !== String(attempt.data?.id)
    ) || []

  if (reportsToRender.length === 0) return null

  return (
    <div className="mb-8 flex flex-col">
      <Typography variant="title3" className="mb-2">
        Previous Reports
      </Typography>
      <div className="rounded-[16px] border border-surface-200">
        {reportsToRender?.map((report, index) => (
          <div key={index}>
            <div className="flex flex-wrap items-center justify-between gap-2 p-2.5">
              <div className="flex flex-row gap-2">
                <img
                  src={CpatCover}
                  alt=""
                  className="h-[100px]"
                  style={{ boxShadow: "0px 4.1px 10.25px 0px #00000024" }}
                />
                <div className="flex flex-col justify-between">
                  <div>
                    <Typography
                      variant="strongSmallBody"
                      className="text-[12px] text-onSurface-500"
                    >
                      REPORT
                    </Typography>
                    <Typography variant="title4" className=" mb-2 mt-1">
                      {isNcte
                        ? "National Council for Teacher Education Assessment"
                        : "Comprehensive Pedagogy Assessment of Teachers"}
                    </Typography>
                  </div>
                  <div className="mb-2 flex flex-wrap items-center gap-1">
                    <div className="flex flex-row gap-1">
                      <Calendar className="size-2" color="onSurface" />
                      <Typography
                        variant={"smallBody"}
                        className="text-onSurface-500"
                      >
                        {formatDate(report.issuedAt, "do MMMM yyyy")}
                      </Typography>
                    </div>
                    <div className="size-1 rounded-xl bg-onSurface-300"></div>
                    <Typography
                      variant={"smallBody"}
                      className="text-onSurface-500"
                    >
                      {formatDistanceToNow(new Date(report.issuedAt), {
                        addSuffix: true,
                      })}
                    </Typography>
                  </div>
                </div>
              </div>
              {report.file && (
                <Link to={report.file}>
                  <Button
                    variant={"outlined"}
                    className="h-min border-gray-300 !px-1.5 !py-1 text-gray-700"
                  >
                    Download Report
                  </Button>
                </Link>
              )}
            </div>
            {index < reportsToRender.length - 1 && (
              <div className="h-px bg-surface-200"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default CpatPreviousReports
